import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { mergeInitialValues } from '@utils/formik';
import { useFormParams, useFormValues } from '@components/HealthQuoteBuyRoute/HealthQuoteBuyForm';

import { selectCancerQuoteBuyRoute } from '../selector';

export const useInitialValues = () => {
  const { cancerQuote } = useSelector(selectCancerQuoteBuyRoute);
  const params = useFormParams();
  const values = useFormValues();
  return useMemo(() => {
    if (!cancerQuote) return;
    const { members, commissionShares } = cancerQuote;
    return mergeInitialValues(
      values,
      members,
      params,
      commissionShares ? { commissionShares } : undefined,
    );
  }, [cancerQuote]);
};
